import { useColorModeValue } from "@chakra-ui/react";

export function ContentBackground() {
  return useColorModeValue("#fff", "#0a0a0a");
}

export function BorderColor() {
  return useColorModeValue("#EFEFEF", "#ffffff29");
}
export function BorderColorReactSelect() {
  return useColorModeValue("#EFEFEF", "var(--chakra-colors-whiteAlpha-300)");
}

export function WhiteDarkColor() {
  return useColorModeValue("#ffffff", "darkBG");
}
export function DarkWhiteColor() {
  return useColorModeValue("#1A1C1E", "#ffffff");
}

export function AssetHover() {
  return useColorModeValue("#FAF089", "#744210");
}

export function DefaultTextColor() {
  return useColorModeValue("darkBG", "#FFFFFF");
}

export function HeaderBG() {
  return useColorModeValue("#FDFDFD", "#0a0a0a");
}
export function BorderColorHC() {
  return useColorModeValue("#1B1B36", "#78789C");
}

export function PropsPickerBG() {
  return useColorModeValue("#868C8F", "#868C8F");
}

export function DataGridTh() {
  return useColorModeValue("#EFEFEF", "#1A1C1E");
}

export function DataGridTextFilter() {
  return useColorModeValue("#fff", "#272A30");
}
export function DataGridTdBorder() {
  return useColorModeValue("#EFEFEF", "#111E34");
}

export function InputColor() {
  return useColorModeValue("#EFEFEF", "#1A1C1E");
}

export function VisitBorder() {
  return useColorModeValue("#E1E1E1", "#494D57");
}
export function VisitBG() {
  return useColorModeValue("transparent", "#1A1C1E");
}

export function VisitHover() {
  return useColorModeValue("blue.50", "gray.800");
}

export function PageBackground() {
  return useColorModeValue("#F5F5F5", "#000000");
}

export function WidgetBackground() {
  return useColorModeValue("#fff", "#0a0a0a");
}
export function WidgetBackgroundInverted() {
  return useColorModeValue("#0a0a0a", "#fff");
}
export function TrHover() {
  return useColorModeValue("gray.200", "gray.800");
}

// Chat
export function ChatGrayBackground() {
  return useColorModeValue("#F5F5F5", "#111E34");
}
export function ChatLightBlack() {
  return useColorModeValue("#000", "#fff");
}
export function ChatHover() {
  return useColorModeValue("#E1E1E1", "#3C4770");
}
export function ChatHDividerLine() {
  return useColorModeValue("#E1E1E1", "#3C4770");
}

export function ChatMessagesBackground() {
  return useColorModeValue("#FDFDFD", "#0a0a0a");
}
export function ChatMyMessageBackground() {
  return useColorModeValue("#F1F5FB", "#111E34");
}
export function ChatMyMessageFontColor() {
  return useColorModeValue("##1A1C1E", "#AFB6C6");
}
export function ActiveModeColor() {
  return useColorModeValue("#1A1C1E", "#ffffff");
}
